import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../api';
import './TosGate.css';

/**
 * TosGate — modal overlay shown to authenticated users whose accepted ToS
 * version doesn't match the current version.  They must accept before
 * proceeding.  The gate checks on mount and whenever the user changes.
 */
const TosGate = () => {
  const { user, isAuthenticated, token } = useAuth();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isAuthenticated || !token) {
      setShow(false);
      return;
    }

    let cancelled = false;

    const checkTos = async () => {
      try {
        const res = await api.get('/api/auth/tos-status');
        if (!cancelled && !res.data.accepted) {
          setShow(true);
        }
      } catch {
        // If the endpoint isn't available yet, don't block the user
      }
    };

    checkTos();
    return () => { cancelled = true; };
  }, [isAuthenticated, token, user]);

  const handleAccept = async () => {
    setLoading(true);
    setError('');
    try {
      await api.post('/api/auth/accept-tos');
      setShow(false);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="tos-gate-overlay">
      <div className="tos-gate-modal">
        <h2>Updated Terms of Service</h2>
        <p>
          We've updated our <Link to="/terms" target="_blank">Terms of Service</Link> and{' '}
          <Link to="/privacy" target="_blank">Privacy Policy</Link>. Please review them and
          accept to continue using AmpNebula.
        </p>

        {error && <div className="tos-gate-error">{error}</div>}

        <button
          className="tos-gate-accept"
          onClick={handleAccept}
          disabled={loading}
        >
          {loading ? 'Accepting…' : 'I Accept'}
        </button>
      </div>
    </div>
  );
};

export default TosGate;
